export const SESSION_STORAGE_KEYS = {
    /** Full URL the player landed on; captured once per tab session. */
    LANDING_URL: 'landingURL',
    /** Set when landing URL is cleared so in-app navigations do not recapture until a new linkout. */
    LANDING_URL_OPT_OUT: 'landingURLOptOut',
    DYNAMO_PAYLOAD: 'dynamoPayload',
    SOURCE: 'source',
    // Sticky client guard after shop rejected the session. Survives stripping
    // `session_expired` from the URL so a remount cannot auto-login again.
    SESSION_REJECTED: 'ac_session_rejected',
    // Sticky guard for OTP query-param auto-login. Survives remounts caused by
    // setSessionAction / RSC refresh while still on /login?proofKey&token, so a
    // second AuthController.login cannot fire with already-consumed OTP creds.
    OTP_LOGIN_ATTEMPTED: 'ac_otp_login_attempted',
    // Durable Mixpanel op queue across deferred init / short reloads.
    ANALYTICS_OPERATION_QUEUE: 'ac_analytics_operation_queue',
    // Player identity read off a pre-auth handoff token, so the hard navigation
    // to /shop or /failed still reports who the landing belonged to.
    PENDING_RUM_IDENTITY: 'ac_pending_rum_identity',
    // Events raised a line before a hard navigation destroys the document, to be
    // reported by the next one. RUM initializes after the main content paints
    // and its SDK batches
    // with no unload flush, so nothing in memory survives the teardown.
    PENDING_RUM_EVENTS: 'ac_pending_rum_events',
    // Sent once per tab session, not again on every footer remount.
    MARKETING_GPC_OPT_OUT_SENT: 'ac_marketing_gpc_opt_out_sent',
}